import * as React from 'react'
import * as ReactMarkdown from 'react-markdown'

import { useTheme } from '../../../theme'

import { Link } from '../../link'

interface ILinkRendererProps {
  children?: React.ReactNode
  href: string
}

export default function LinkRenderer({ href, children }: ILinkRendererProps) {
  const theme = useTheme()

  return (
    <Link
      href={ReactMarkdown.uriTransformer(href)}
      rel="noopener noreferrer"
      style={{
        fontWeight: theme.settings.typography.weights.normal,
        fontSize: 'inherit',
        lineHeight: 'inherit',
      }}
      target="_blank"
      underline
      variant="primary"
    >
      {children}
    </Link>
  )
}
